// extracted by mini-css-extract-plugin
export var header = "_f5-0";